import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getClientConfig } from "../../config/app";
import { useSelector } from "react-redux";
import { RootStateType } from "../../redux/features/rootSlice";

export function setCookie(data: string, exdays: number, clientId: string) {
  // const d = new Date();
  // d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  // console.log("clientId in setcookie", clientId);
  const clientConfig = getClientConfig(clientId);
  // console.log("clientConfig in setcookie", clientConfig);
  let expires = "expires=" + new Date(exdays).toUTCString()
  //document.cookie = data + ";" + expires + ";path=/";
  document.cookie = `${data}; ${expires}; path=/; domain=${clientConfig?.domain}; secure; HttpOnly SameSite=Lax`;
}

export function removeCookie(data: string, exdays: number, clientId: string) {
  // console.log("clientId in setcookie", clientId);
  const clientConfig = getClientConfig(clientId);
  // console.log("clientConfig in setcookie", clientConfig);
  let expires = "expires=" + new Date(exdays).toUTCString()
  document.cookie = `${data}; ${expires}; path=/; domain=${clientConfig?.domain}; secure; HttpOnly SameSite=Lax`;
  document.cookie = `${data}; ${expires}; path=/; domain=${'stgprofile.'+clientConfig?.domain}; secure; HttpOnly SameSite=Lax`;
}

export function getCookie(key: string) {
  let name = key + "=";
  let ca = document.cookie?.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c?.charAt(0) === " ") {
      c = c?.substring(1);
    }
    if (c?.indexOf(name) === 0) {
      return c?.substring(name?.length, c?.length);
    }
  }
  return "";
}

const Token = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const storedClientId = useSelector((state: RootStateType) => state.configStateReducer.clientId);
  useEffect(() => {
    const at = searchParams.get("app.at");
    const rt = searchParams.get("app.rt");
    const at_exp = searchParams.get("app.at_exp");
    // console.log("at-exp",typeof(at_exp));
    // console.log("at-exp",at_exp);
    if (at && rt && at_exp) {
      setCookie(`app.at=${at}`, parseInt(at_exp), storedClientId);
      setCookie(`app.rt=${rt}`, parseInt(at_exp), storedClientId);
      setCookie(`app.at_exp=${at_exp}`, parseInt(at_exp), storedClientId);

      navigate("/");

      // console.log({
      //   "app.at": getCookie("app.at"),
      //   "app.rt": getCookie("app.rt"),
      //   "app.at_exp": getCookie("app.at_exp"),
      // });
    }
  }, [searchParams]);

  return <div></div>;
};

export default Token;
